import { DocumentType, LineItemListing } from '@/modules/fulfillment/context/FulfillmentContext.tsx';
import { captureException } from '@sentry/react';
import { useHttpClientContext } from '@/shared/context/HttpClientContext.tsx';

export function useSetDocumentsAsBilled() {
    const { documentManagementBridgeClient } = useHttpClientContext();

    return async function setDocumentsAsBilled(lineItemListings: LineItemListing[], documents: DocumentType[]) {
        const dmsDocumentsIds = new Set<number>();

        lineItemListings.forEach(lineItemListing => {
            lineItemListing.documentUrls?.forEach(documentUrl => {
                const document = documents.find(doc => doc.url === documentUrl);

                if (document && document.source === 'dms') {
                    const dmsDocumentId = document.fileName.split('.')[0];
                    const parsedId = parseInt(dmsDocumentId);

                    if (!isNaN(parsedId)) {
                        dmsDocumentsIds.add(parsedId);
                    }
                }
            });
        });

        const promises: Promise<unknown>[] = [];

        for (const id of dmsDocumentsIds) {
            const request = documentManagementBridgeClient.fetch.PATCH('/v1/documents/{id}/tags', {
                params: { path: { id: id } },
                body: {
                    tag: 'billed',
                },
            });

            promises.push(request);
        }

        try {
            await Promise.all(promises);
        } catch (error) {
            captureException(error);
        }
    };
}
